<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="['fråga', 'frågor', 'Ny fråga']"
			:pagination="pagination"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			@toggleAdd="toggleAddQuestion"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns" @click="closeAdd()">
			<QuestionList
				:questions="questions"
				:questionGroup="questionGroup"
				@delete="askToDeleteQuestion"
				@edit="editQuestion"
				@search="getQuestions()"
			/>
		</main>
		<addQuestion
			v-if="showAddQuestion"
			@cancel="closeAdd"
			@save="saveQuestion"
			:editQuestion="selectedQuestion"
		/>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import QuestionList from './components/QuestionList';
import AddQuestion from './modals/AddQuestion';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		QuestionList,
		AddQuestion,
		DeleteModal,
		TopPanel
	},
	data() {
		return {
			showAddQuestion: false,
			showDelete: false,
			selectedQuestion: {},
			orderBys: [
				{ name: 'Namn', value: 'Name' },
				{ name: 'Skapad', value: 'Created' }
			]
		};
	},
	computed: {
		...mapState('questionStore', ['searchParams']),
		...mapGetters('questionStore', ['questions', 'pagination']),
		...mapGetters('questionGroupStore', ['questionGroup']),
		...mapGetters('user', ['getActiveCustomer']),

		deleteMessage() {
			return this.selectedQuestion.name
				? `Är du säker på att du vill ta bort ${this.selectedQuestion.name}?`
				: '';
		}
	},

	watch: {
		'getActiveCustomer.id'() {
			this.$router.push({ name: 'QuestionsView' });
		}
	},

	methods: {
		...mapActions('questionStore', [
			'setQuestion',
			'getQuestions',
			'createQuestion',
			'updateQuestion',
			'deleteQuestion',
			'setCurrentPage',
			'setPageSize'
		]),
		...mapActions('questionGroupStore', ['getQuestionGroup']),
		toggleAddQuestion() {
			this.showAddQuestion = !this.showAddQuestion;
			this.selectedQuestion = {};
		},
		closeAdd() {
			if (window.getSelection().toString() == '') {
				this.showAddQuestion = false;
				this.selectedQuestion = {};
			}

			if (this.showDelete) {
				this.showDelete = false;
				this.selectedQuestion = {};
			}
		},
		askToDeleteQuestion(question) {
			this.showAddQuestion = false;
			Object.assign(this.selectedQuestion, question);
			this.showDelete = true;
		},
		cancelDelete() {
			this.showDelete = false;
		},
		deleteSelected() {
			this.deleteQuestion(this.selectedQuestion).then(() => {
				this.getQuestions();
				this.showDelete = false;
			});
		},
		search(searchValue) {
			this.searchParams.name = searchValue;
			this.getQuestions();
		},
		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getQuestions();
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.getQuestions();
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.getQuestions();
		},
		saveQuestion(question) {
			if (this.selectedQuestion.id) {
				this.updateQuestion(question).then(() => {
					this.showAddQuestion = false;
					this.selectedQuestion = {};
					this.getQuestions();
				});
			} else {
				question.questionGroupId = this.$router.params.questionGroupId;
				this.createQuestion(question).then(() => {
					this.showAddQuestion = false;
					this.getQuestions();
				});
			}
		},
		editQuestion(question) {
			if (this.selectedQuestion == question) {
				this.selectedQuestion = {};
				this.showAddQuestion = false;
			} else {
				this.selectedQuestion = question;
				this.showAddQuestion = true;
			}
		}
	},
	created() {
		this.searchParams.questionGroupId = this.$route.params.questionGroupId;
		this.getQuestions();
		this.getQuestionGroup(this.$route.params.questionGroupId);
	}
};
</script>
